import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "faq"
    }}>{`FAQ`}</h1>
    <p>{`A `}<strong parentName="p">{`FAQ page`}</strong>{` is a web page that lists common questions and answers about a specific product, service, or topic. It is designed to provide quick and easy access to information that users frequently seek.`}</p>
    <h2 {...{
      "id": "admin-dashboard"
    }}>{`Admin dashboard`}</h2>
    <p>{`In admin dashboard super admin can entry all the related FAQs about his business, site operations, payments etcetera. This will count as a global FAQ.`}</p>
    <blockquote>
      <p parentName="blockquote">{`FAQs CRUD operations.`}</p>
    </blockquote>
    <p><img alt="super-admin-faq-list" src={require("./images/revamp/super-admin-faqs-list.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`In Shop End`}</p>
    </blockquote>
    <p><img alt="super-admin-faq-shop" src={require("./images/revamp/super-admin-faq-shop.png")} /></p>
    <h2 {...{
      "id": "vendor-dashboard"
    }}>{`Vendor dashboard`}</h2>
    <p>{`Vendor can listed their FAQs based on their specific shop. This FAQs will display in shop/Author specific page.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Vendor FAQs CRUD operations.`}</p>
    </blockquote>
    <p><img alt="vendor-faq-list" src={require("./images/revamp/vendor-faq-list.png")} /></p>
    <blockquote>
      <p parentName="blockquote">{`In Shop End`}</p>
    </blockquote>
    <p><img alt="vendor-faq-shop" src={require("./images/revamp/vendor-faq-shop.png")} /></p>
    <h2 {...{
      "id": "shop-end"
    }}>{`Shop End`}</h2>
    <p>{`Finally you find FAQ here `}<inlineCode parentName="p">{`/help`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      